import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import {
  useWishlistItems,
  useWishlistTotalCount,
  LocalLabelsProvider,
} from '@sentecacommerce-theme/lib'
import { ProductCard, EmptyWishlist } from './Components'
import { FavoritesProps, FavoritesLabels } from './favorites.props'
import { Heading, Spinner } from '../Common'

export const Favorites = ({ title, labels }: FavoritesProps) => {
  const { items } = useWishlistItems()
  const wishlistTotalCount = useWishlistTotalCount()
  const [showSpinner, setShowSpinner] = useState(false)

  const isEmpty = wishlistTotalCount === 0

  useEffect(() => {
    setShowSpinner(true)
    const timer = setTimeout(() => setShowSpinner(false), 400)
    return () => {
      clearTimeout(timer)
    }
  }, [wishlistTotalCount])

  // TODO: loading state
  return (
    <LocalLabelsProvider<FavoritesLabels> labels={labels}>
      <Container>
        <Heading isCentered data={title} topTitle className="my-5" />
        {!isEmpty && showSpinner && (
          <LoaderContainer>
            <Spinner />
          </LoaderContainer>
        )}
        {isEmpty && (
          <>
            <EmptyWishlist />
          </>
        )}
        {!showSpinner && (
          <ProductListContainer>
            {items?.map((product) => {
              return (
                <ItemContainer key={`product__${product.variantId}`}>
                  <ProductCard item={product} />
                </ItemContainer>
              )
            })}
          </ProductListContainer>
        )}
      </Container>
    </LocalLabelsProvider>
  )
}

const ItemContainer = styled.article``

const Container = styled.section.attrs({
  className: 'container',
})``

const ProductListContainer = styled.div.attrs({
  className:
    'row row-cols-2 row-cols-md-3 row-cols-lg-5 g-3 g-md-4 g-lg-5 mt-1',
})``

const LoaderContainer = styled.div.attrs({
  className: 'd-flex align-items-center justify-content-center',
})`
  height: 28rem;
  position: relative;
`
